import * as Sentry from "@sentry/react";
import { DATA_PRODUCER_WORKSHEET_NAME } from "../globalValues";
import { getQuoteFeederIdByName } from "../sourceServices";
import { InsertUpdatedSecurityValues } from "../store/types";
import { validateYieldValue } from "../validators";
import {
  ASK_IDX,
  BID_IDX,
  DATA_PRODUCER_TABLE_NAME,
  ISIN_IDX,
  NAME_IDX,
  QUOTE_FEED_IDX,
  ROW_ID_IDX,
} from "./constants";

const ADJUSTED_ROW = 2;

const validateYield = (yieldValue: string) => {
  try {
    validateYieldValue(yieldValue);
    return true;
  } catch (error) {
    return false;
  }
};

export const getDataOfSecuritiesFromDataProducerTable = async (): Promise<InsertUpdatedSecurityValues[]> => {
  const securities: InsertUpdatedSecurityValues[] = [];

  await Excel.run(async (context) => {
    const worksheet = context.workbook.worksheets.getItem(DATA_PRODUCER_WORKSHEET_NAME);
    const table = worksheet.tables.getItemOrNullObject(DATA_PRODUCER_TABLE_NAME);

    if (!table) return;

    const securitiesValues = table.getDataBodyRange().load("values");
    await context.sync();

    const securitiesInTable = securitiesValues.values;

    for (let securityIndex = 0; securityIndex < securitiesInTable.length; securityIndex++) {
      const row = securitiesInTable[securityIndex];

      const quoteFeedName = row[QUOTE_FEED_IDX];
      const ask = row[ASK_IDX];
      const bid = row[BID_IDX];

      let validAsk = validateYield(ask);
      let validBid = validateYield(bid);

      if (quoteFeedName === "None" || (!validAsk && !validBid)) continue;

      let quoteFeedId = "";

      try {
        quoteFeedId = await getQuoteFeederIdByName(context, quoteFeedName);
      } catch (error) {
        Sentry.captureException(
          new Error('Error getting quote feeder ID', { cause: error }),
        );
        continue;
      }

      securities.push({
        securityProducerId: row[ROW_ID_IDX],
        isin: row[ISIN_IDX],
        securityName: row[NAME_IDX],
        ask: !validAsk ? "" : row[ASK_IDX],
        bid: !validBid ? "" : row[BID_IDX],
        quoteFeedId,
        quoteFeedName,
        row: securityIndex + ADJUSTED_ROW,
      });
    }
  });

  return securities;
};
